/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/trusted-devices/${encodeURIComponent(request.path['deviceId'] as any)}/status`,
    // @ts-ignore for sm-axios
    urlTemplate: '/trusted-devices/{deviceId}/status',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * Check the registration status of a trusted device. Forwards to authx-auth-api with the email extracted from the token in the request body.
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  path: {
    deviceId: string
  }
  body: {
    /**
     * JWT issued by login-beef. The user email is extracted from it.
     */
    token: string
  }
}

export type Response =
  | {
      /**
       * UUID of the trusted device.
       */
      deviceId: string
      /**
       * Registration status of the trusted device.
       */
      status: 'pending' | 'confirmed'
      /**
       * ISO 8601 timestamp of when the device was enrolled (only present when status is confirmed)
       */
      requestedAt?: string
      /**
       * User-Agent string of the device (only present when status is confirmed)
       */
      userAgent?: string
      /**
       * City derived from the request IP address (only present when status is confirmed)
       */
      city?: string
      /**
       * Country derived from the request IP address (only present when status is confirmed)
       */
      country?: string
    }
  | {
      /**
       * The trusted device was not found for this user + deviceId.
       */
      code: 'TrustedDeviceNotFound'
    }

